import React from "react";
import { Link } from "react-router-dom";
import "../css/Footer.css";
import { useTranslation } from "../context/LanguageContext";

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t, dictionary } = useTranslation();
  const navLinks = [
    { to: "/overons", label: t("nav.overOns") },
    { to: "/menu", label: t("nav.menu") },
    { to: "/reserveren", label: t("nav.reserveren") },
    { to: "/contact", label: t("nav.contact") }
  ];

  const footerText = dictionary.footer || {};
  const common = dictionary.common || {};
  const contactInfo = common.contact || {};
  const addressText = contactInfo.addressLines?.join(', ') || '';
  const phoneNumber = contactInfo.phone || '';
  const emailAddress = contactInfo.email || '';
  const hours = common.openingHours || [];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo Section */}
        <div className="footer-logo-section">
          <Link to="/" className="footer-logo">
            <img src="/assets/images/Logo.png" alt="Lamara Shisha Bar" />
          </Link>
          <p className="footer-tagline">{footerText.tagline}</p>
        </div>

        {/* Navigation Links */}
        <div className="footer-nav-section">
          <h3>{footerText.navigationTitle}</h3>
          <ul className="footer-nav">
            {navLinks.map((link) => (
              <li key={`footer-${link.to}`}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Information */}
        <div className="footer-contact-section">
          <h3>{footerText.contactTitle}</h3>
          <ul className="footer-contact">
            <li>
              <i className="fas fa-map-marker-alt"></i>
              <span>{addressText}</span>
            </li>
            <li>
              <i className="fas fa-phone"></i>
              <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </li>
            <li>
              <i className="fas fa-envelope"></i>
              <span>{emailAddress}</span>
            </li>
          </ul>
        </div>
        <div className="footer-hours-section">
          <h3>{footerText.hoursTitle}</h3>
          <ul className="footer-hours">
            {hours.map((item) => (
              <li key={`footer-hours-${item.day}`}>
                <span>{item.day}:</span> <strong>{item.time}</strong>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Social Media Icons */}
      <div className="footer-social">
        <a href="https://www.facebook.com/groups/1734899870093801/" target="_blank" rel="noreferrer" aria-label="Facebook">
          <i className="fab fa-facebook"></i>
        </a>
        <a href="https://www.instagram.com/lamaralounge" target="_blank" rel="noreferrer" aria-label="Instagram">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://www.whatsapp.com" target="_blank" rel="noreferrer" aria-label="Whatsapp">
          <i className="fab fa-whatsapp"></i>
        </a>
        <a href="https://www.tiktok.com/@lamaralounge" target="_blank" rel="noreferrer" aria-label="TikTok">
          <i className="fab fa-tiktok"></i>
        </a>
      </div>

      {/* Copyright */}
      <div className="footer-copyright">
        <p>
          &copy; {currentYear} Lamara Shisha Bar. {footerText.rights}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
